<ng-container *transloco="let t">
	<span class="game-image">
		@if (item().imageUrl) {
			<img [src]="item().imageUrl" [alt]="item().label" loading="lazy" />
		}
	</span>

	<span class="game-text">
		<span class="game-name truncate-text" [title]="item().label">{{ item().label }}</span>

		<span class="game-info">
			@if (item().category) {
				<span class="info-item info-category">{{ item().category }}</span>
			}

			<!-- Hidden until the design gives the line room on small phones: with it,
			the category is cut short. The count is still mapped (followers()), so
			bringing it back is uncommenting this.
			<span class="info-item">
				<span class="info-value">{{ followers() }}</span>
				<span class="info-label">{{ t('casino.followers') }}</span>
			</span>
			-->

			@if (rtp(); as rtp) {
				<span class="info-item">
					<span class="info-value">{{ rtp }}%</span>
					<span class="info-label">{{ t('casino.rtp') }}</span>
				</span>
			}
		</span>

		@if (item().providerName) {
			<span class="game-provider truncate-text">{{ item().providerName }}</span>
		}
	</span>

	<span class="game-play">
		<base-icon class="play-icon" [icon]="PlayIcon" />

		<span class="players">
			<span class="players-count">
				<span class="players-dot" aria-hidden="true"></span>
				{{ playing() }}
			</span>
			<span class="players-label">{{ t('casino.playingNow') }}</span>
		</span>
	</span>
</ng-container>
